export default {
    'facility_management': 'Konfiguracja obiektów',
    'client_management': 'Zarządzanie bazą klientów',
    'service_management': 'Konfiguracja usług',
    'resource_management': 'Konfiguracja zasobów i ich kategorii',
    'business_management': 'Konfiguracja ustawień biznesu',
    'partner_management': 'Konfiguracja kont pracowników',
    'partner_invite': 'Zapraszanie pracowników do aplikacji',
    'permission_management': 'Zarządzanie rolami i uprawnieniami pracowników',
}